import { css } from "styled-components";

/**
 * The line between the rows of a frame: inset by the frame's padding (as the Settings cards' footer line), never
 * from edge to edge. Drawn by the row's ::before, so its hover background and tinted notices still fill the frame.
 */
export const insetDivider = (inset = "20px", color = "var(--color-neutral-base)") => css`
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    right: ${inset};
    left: ${inset};
    height: 1px;
    content: "";
    background: ${color};
    pointer-events: none;
  }
`;
